// extracted by mini-css-extract-plugin
export var box = "_22-2";
export var checkboxControl = "_22-0";
export var checkboxRow = "_22-a";
export var checked = "_22-3";
export var descriptionSpacer = "_22-c";
export var disabled = "_22-4";
export var icon = "_22-8";
export var input = "_22-1";
export var labelSpacer = "_22-b";
export var large = "_22-7";
export var medium = "_22-6";
export var small = "_22-5";
export var text = "_22-9";